<template>
    <div class="legal-person-step1" v-loading="pageLoading">
        <el-form ref="formData" class="sr-from-single" label-width="200px" :model="formData">
            <el-form-item prop="entLicenceFile" label="个体工商户营业执照" :rules="[{required: true, message: '请上传个体工商户营业执照图片'}]">
                <ImageUpload
                    class="horizontal"
                    :url.sync="formData.entLicenceFile"
                    accept="image/png,image/jpeg"
                    :size="10"
                    fixedNumber="4:3"
                    crop
                    :drag="false"
                    @onSuccess="handleImageSuccess"
                >
                    <template slot="tips">
                        <b style="color: #000">上传后，将自动读取，内容可修改</b>
                        <br />
                        提示：
                        <br />
                        1. 证件照片应清晰可见容易识别，且边框完整
                        <br />
                        2. 必须真实拍摄，不能使用复印件
                        <br />
                        3. 大小不超过10M
                        <br />
                        4. 仅支持 .png、.jpg、.jpeg
                    </template>
                </ImageUpload>
            </el-form-item>
            <el-form-item prop="entName" label="个体工商户名称" :rules="[{required: true, message: '请输入个体工商户名称'}]">
                <el-input v-model="formData.entName" placeholder="请输入个体工商户名称" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="个体工商户经营者姓名">
                <el-input v-model="formData.corporateName" disabled placeholder="请输入个体工商户经营者姓名" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item prop="showCorporateIdCard" label="个体工商户经营者身份证号">
                <el-input v-model="showCorporateIdCard" disabled placeholder="请输入个体工商户经营者身份证号" maxlength="18"></el-input>
            </el-form-item>
            <el-form-item prop="entQualificationType" label="证件类型">
                <el-select v-model="formData.entQualificationType" placeholder="请选择">
                    <el-option :value="3" label="个体工商户营业执照统一社会信用代码"></el-option>
                    <el-option :value="4" label="个体工商户营业执照注册号"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                prop="entQualificationNum"
                label="证件编号"
                :rules="[
                    {required: true, message: '请输入证件编号'},
                    {pattern: /^[A-Za-z0-9]+$/, message: '请输入正确的证件编号格式'},
                ]"
            >
                <el-input v-model="formData.entQualificationNum" placeholder="请输入证件编号" maxlength="18"></el-input>
            </el-form-item>
            <el-form-item label="">
                <el-button @click="previousStep()">上一步</el-button>
                <el-button type="primary" :loading="loading" @click="onSubmit">下一步</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import ImageUpload from '@/components/ImageUpload';
import {enterpriseCertify, setEnterpriseStep, enterpriseLicense} from '@/api/user';
export default {
    components: {
        ImageUpload,
    },
    data() {
        return {
            pageLoading: false,
            loading: false,
            formData: {
                corporateIdCard: null, // 企业法人身份证号
                corporateName: '', // 企业法人姓名
                entLicenceFile: null, // 企业营业执照图片
                entName: '', // 企业名称
                entQualificationNum: null, // 企业资质编号
                entQualificationType: 3, //企业资质编号类型
            },
            showCorporateIdCard: '',
        };
    },
    mounted() {
        this.initFrom();
    },
    methods: {
        async previousStep() {
            const flag = await this.$confirm(`返回后当前页面的信息将不会保存。`, '确定要返回操作吗？');
            if (flag === 'cancel') return;
            const respnose = await setEnterpriseStep(0);
            const {state, msg} = respnose.data;
            if (!state) return this.$message.error(msg || '返回上一步失败，请稍后尝试');
            await this.$store.dispatch('getEnterpriseCertify', true);
            this.$router.replace(this.$contractRouter('/manage/contract/enterprise/fdd', 'url'));
        },
        maskSensitiveInfo(idNumber) {
            if (typeof idNumber !== 'string' || idNumber.length !== 18) {
                throw new Error('Invalid ID number format');
            }

            const maskedPart = '*'.repeat(idNumber.length - 6);
            const maskedIdNumber = `${idNumber.slice(0, 3)}${maskedPart}${idNumber.slice(-3)}`;
            return maskedIdNumber;
        },
        // 表单初始化 注：只有是法人本人才能进行初始化设置
        async initFrom() {
            const {certifyInfo} = this.$store.getters;
            this.formData = {...this.formData, ...certifyInfo};
            const {corporateIdCard} = certifyInfo || {};
            this.showCorporateIdCard = this.maskSensitiveInfo(corporateIdCard);
        },
        // 获取营业执照信息
        async getLicenseInfo(path) {
            const respnose = await enterpriseLicense(path);
            const {state, msg, result} = respnose.data;
            if (!state) return this.$message.error(msg || '获取数据失败,请重试');
            const {entName, entQualificationNum} = result;
            this.formData = {...this.formData, ...{entName, entQualificationNum}};
        },
        async onSubmit() {
            const valid = await this.$refs['formData'].validate();
            if (!valid) return;
            this.loading = true;
            const formData = JSON.parse(JSON.stringify(this.formData));
            const respnose = await enterpriseCertify(this.$store.getters.enterpriseUpgradeType, formData);
            const {state, msg} = respnose.data;
            this.loading = false;
            if (!state) {
                this.$confirm(`<p class="error">失败原因：${msg || ''}</p>`, '企业资质信息校验失败', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '修改资料',
                });
                return false;
            }
            this.$emit('updateStep');
        },
        handleImageSuccess(data) {
            const {url} = data;
            if (url) {
                this.formData.entLicenceFile = url;
                this.getLicenseInfo(url);
            }
        },
    },
};
</script>
<style lang="scss" scoped></style>
